<div class="modal-header d-flex justify-content-between align-items-center">
  <h5 class="modal-title">
    <i class="bx bx-photo-album me-2"></i> {{ slide.title }}
  </h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="activeModal.close('Close')"></button>
</div>
<div class="modal-body text-center">
  <img [src]="slide?.mediaUrl" class="img-fluid-fixed rounded mb-3" />
  <p *ngIf="!slide">No image selected yet.</p>
  <div class="d-flex justify-content-end gap-2">
    <input type="file" #fileInput (change)="uploadImage($event)" accept="image/*" style="display: none;" ngbAutofocus>
    <button type="button" class="btn btn-secondary truncate-text" (click)="selectAndUpsertImage()">
      <i *ngIf="!isLoading" class="bx bx-image"></i> 
      {{ selectedFileName || 'Change Slide' }}
      <div *ngIf="isLoading" role="status" class="spinner-border spinner-border-sm text-primary">
        <span class="visually-hidden">Loading...</span>
        </div>
    </button>
  </div>
</div>